module.exports = __webpack_public_path__ + "static/img/tiktok.169922db.png";